exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-padding {\n  padding: 10px; }\n\n.pic {\n  max-width: 100%;\n  max-height: 100%;\n  width: 100px;\n  height: 100px;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  padding: 10px; }\n\n.backgroundcolor {\n  background-color: #00778B; }\n\n.navbar-right {\n  margin-right: 0px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Projects/Isagenix/GitHub/Mobile.IsaLifeAzure/apps/qualia-platform-admin-web/src/app/layout/header/header.component.scss
// module id = ../../../../../src/app/layout/header/header.component.scss
// module chunks = main